import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

// iter-119ag — Radix `Slider` renders one Thumb per value passed in.
// Stock shadcn shipped with a single hard-coded <Thumb /> which made
// dual-handle sliders impossible (only the lower thumb was draggable).
// We now derive the thumb count from the `value` / `defaultValue` prop
// length and render one per index so range sliders work out of the box.
const Slider = React.forwardRef(({ className, value, defaultValue, ...props }, ref) => {
    const thumbCount = Array.isArray(value)
        ? value.length
        : (Array.isArray(defaultValue) ? defaultValue.length : 1);
    return (
        <SliderPrimitive.Root
            ref={ref}
            value={value}
            defaultValue={defaultValue}
            className={cn("relative flex w-full touch-none select-none items-center", className)}
            {...props}>
            <SliderPrimitive.Track
                className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20">
                <SliderPrimitive.Range className="absolute h-full bg-primary" />
            </SliderPrimitive.Track>
            {Array.from({ length: thumbCount }).map((_, i) => (
                <SliderPrimitive.Thumb
                    key={i}
                    aria-label={i === 0 ? "Minimum" : i === thumbCount - 1 ? "Maximum" : `Value ${i + 1}`}
                    className="block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
                />
            ))}
        </SliderPrimitive.Root>
    );
});
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
